<template>
  <div class="infoMenu">
    <modal v-if='bugReport'>
      <div slot='header'>Beskriv en bugg eller din synpunkt nedan.</div>
      <div slot='body'>
        <textarea id='bugreport-text'></textarea>
      </div>
      <div slot='footer'>
        <div class='modal-button' v-on:click="$store.commit('showBugReport', false)">Avbryt</div>
        <div class='modal-button' v-on:click="reportABug">Skicka</div>
      </div>
    </modal>
    <div class='inside-closer' v-on:click="$store.commit('showInfoMenu', false)">✖</div>
    <div class='menu-header'>General</div>
    <a class='list-item' href='https://game.exhibitionstockholm.se'>
      <div class='title'>Start</div>
      <div class='subtitle'>Gå till startsidan</div>
    </a>
    <a class='list-item' href='https://game.exhibitionstockholm.se/#/tutorial'>
      <div class='title'>Guide</div>
      <div class='subtitle'>Gå till startguiden</div>
    </a>
    <a class='list-item' href='https://helpx.adobe.com/lightroom/how-to/lightroom-mobile.html' target='_blank'>
      <div class='title'>Lightroom Mobile</div>
      <div class='subtitle'>Kom igång med Lightroom Mobile</div>
    </a>
    <div class='list-item' v-on:click="$store.commit('showBugReport', true)">
      <div class='title'>Hör av dig</div>
      <div class='subtitle'>Skicka en bugg eller andra synpunkter på spelet!</div>
    </div>
    <div class='list-item' v-for='listItem in list'>
      <div class='title'>{{listItem.title}}</div>
      <div class='subtitle'>{{listItem.subtitle}}</div>
    </div>
  </div>
</template>

<script>
import modal from '@/components/Modal'
export default {
  name: 'infoMenu',
  data () {
    return {
      list: [
        {
          title: 'v1.0 Exhibition Stockholm',
          subtitle: '29 June 2017'
        }
      ]
    }
  },
  computed: {
    bugReport () {
      return this.$store.state.bugReport
    }
  },
  methods: {
    close () {},
    reportABug () {
      if (window.ga) {
        window.ga('send', 'event', 'Report', 'open', 'Bug Report')
      }
      let text = document.getElementById('bugreport-text').value
      if (text.length < 1) {
        this.$store.commit('interupt', 'Skriv nått innan du skickar in!')
      } else {
        this.$store.dispatch('reportABug', {
          text: text
        })
      }
    }
  },
  mounted () {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Info Menu')
    }
  },
  components: { modal }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .infoMenu {
    position: absolute;
    min-height: 100vh;
    top: 0px;
    left: 0px;
    right: 0px;
    background-color: #FFF;
    z-index: 99999;
    overflow-x: hidden;
  }
  .infoMenu a {
    color: inherit;
  }
  a.list-item {
    display: block;
  }
  #bugreport-text {
    font-family: inherit;
    border: 0px;
    width: 100%;
    background-color: #f3f3f3;
    height: 100px;
  }
  .menu-header {
    text-align: left;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 30px 20px;
  }
  .modal-button {
    text-align: right;
    margin: 10px;
    font-size: 14px;
    font-weight: bold;
    opacity: 0.8;
    display: inline-block;
    text-transform: uppercase;
  }
  .list-item {
    text-align: left;
    padding: 20px 20px;
    cursor: pointer;
  }
  .list-item .title {
    font-weight: bold;
  }
  .list-item .subtitle {
    opacity: 0.6;
    font-size: 16px;
    line-height: 22px;
    padding: 5px 0px;
  }
</style>



// WEBPACK FOOTER //
// infoMenu.vue?5ec0c8f9